module.exports = __webpack_public_path__ + "img/S1051435.65219380.jpg";